export const getNamedAttribute = (pass: Pass) => {
    return pass.employeename ?? pass.employeeid ?? pass.passid ?? pass.role ?? "unnamed record"
  }